import Vue from "vue";
import Affix from "@/components/Affix";

Vue.use(Affix);
